import { render } from "./EvidenceAttachment.vue?vue&type=template&id=91ba406e&scoped=true"
import script from "./EvidenceAttachment.vue?vue&type=script&lang=js"
export * from "./EvidenceAttachment.vue?vue&type=script&lang=js"

import "./EvidenceAttachment.vue?vue&type=style&index=0&id=91ba406e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ba406e"]])

export default __exports__